import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { ErrorBlock, I18n, Preloader } from 'components';

import { InsuranceBanner, CurrentInsurance } from './components';

import { fetchData } from './actions';
import {
  getTotalPricePolicies, getInsurancePolicies,
  getAbTestVar, getIsErrorStatus, getIsFetchingStatus, getPresetUrl,
} from './selectors';
import { policeShape } from './shapes';
import { withViewAnalytics } from '../../utils/hocs/withViewAnalytics';

const Insurance = ({
  isFetching, isError, abTestVar, presetUrl, policies, fullPrice, fetchInsuranceData,
}) => {
  useEffect(() => {
    fetchInsuranceData();
  }, []);

  if (isFetching) {
    return <Preloader size="80" />;
  }

  if (isError) {
    return (
      <ErrorBlock
        title={<I18n path="insurance.blockTitle" />}
        refreshAction={fetchInsuranceData}
      />
    );
  }

  if (policies.length) {
    return (
      <CurrentInsurance policies={policies} presetUrl={presetUrl} fullPrice={fullPrice} />
    );
  }

  return (
    <InsuranceBanner abTestVar={abTestVar} />
  );
};

const mapStateToProps = (state) => ({
  isFetching: getIsFetchingStatus(state),
  isError: getIsErrorStatus(state),
  abTestVar: getAbTestVar(state),
  presetUrl: getPresetUrl(state),
  policies: getInsurancePolicies(state),
  fullPrice: getTotalPricePolicies(state),
});

const mapDispatchToProps = {
  fetchInsuranceData: fetchData,
};

Insurance.propTypes = {
  presetUrl: PropTypes.string,
  policies: PropTypes.arrayOf(PropTypes.shape(policeShape)),
  fetchInsuranceData: PropTypes.func,
  isError: PropTypes.any,
  isFetching: PropTypes.bool,
  abTestVar: PropTypes.number,
  fullPrice: PropTypes.number,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withViewAnalytics,
)(Insurance);
